import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Api from '@/services';
import { notification } from 'antd';
import { judgeArr, uniqueArr, getDataType } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
const initState = {
    activeState: '',
    tableTotal: 0,
    pageIndex: 1,
    pageSize: 9,
    searchData: {},
    tableData: [],
    loading: false,
    tabList: [
        {
            label: '待发拍',
            key: '0',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-ccdfpenter',
        },
        {
            label: '预展中',
            key: '1',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-ccyuzhanenter',
        },
        {
            label: '投标中',
            key: '5',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-cctoubiaoenter',
        },
        {
            label: '竞拍中',
            key: '2',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-ccjingpaizhongenter',
        },
        {
            label: '已结束',
            key: '3',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-ccjingpaizhongenter',
        },
        {
            label: '已撤销',
            key: '4',
            num: fontEndConfig.noValueReplace,
            allow: 'psgjb-auctionmanadone-ccyichexiaoenter',
        },
    ],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        // 获取有权限的tabList
        dealTabListWithAllow(payload, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { tabList } = state;
                const { global } = rootState;
                const resources = global.resources || [];
                const dealTabList = tabList.filter(({ allow }) => (
                // @ts-ignore
                !allow || resources.includes(allow)));
                this.SET_STATE({
                    tabList: dealTabList,
                    activeState: dealTabList.length > 0 ? dealTabList[0].key : '',
                });
            });
        },
        // 获取tabs数据
        loadTabsData(payload, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { searchData } = state;
                if (searchData.time) {
                    searchData.queryStartDate = searchData.time[0];
                    searchData.queryEndDate = searchData.time[1];
                    delete searchData.time;
                }
                Api.auction.queryRoundStatusNum(Object.assign({}, searchData)).then((_r) => {
                    this.SET_TABLELIST_NUM(_r);
                });
            });
        },
        // 获取卡片列表数据
        updateTable({ page }, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { activeState, searchData, pageIndex, pageSize } = state;
                if (activeState === '') {
                    console.log('tablist为空 不去请求卡片列表接口');
                    return;
                }
                const stateParams = { roundStatus: activeState };
                if (searchData.time) {
                    searchData.queryStartDate = searchData.time[0];
                    searchData.queryEndDate = searchData.time[1];
                    delete searchData.time;
                }
                const searchParams = Object.assign(Object.assign(Object.assign({}, searchData), stateParams), { pageIndex: page || pageIndex, pageSize });
                this.SET_STATE({
                    loading: true,
                });
                Api.auction.queryPageAuctionRound(searchParams).then((res) => {
                    const { items, totalNumber } = res;
                    const dealItems = judgeArr(items) ? uniqueArr(items) : [];
                    this.SET_STATE({
                        tableData: dealItems,
                        tableTotal: totalNumber,
                        pageIndex: page || pageIndex,
                    });
                }).finally(() => {
                    this.SET_STATE({
                        loading: false,
                    });
                });
            });
        },
        // desc 跳转到车辆详情
        linkToDetail(link) {
            const { path, query } = link;
            dispatch.router.push({
                path,
                query,
            });
        },
        // 撤销
        cancel(data) {
            Api.auction.cancelPageAuctionRound({
                roundId: data.roundId,
            }).then((res) => {
                // console.log(res)
                if (res) {
                    notification.success({
                        message: '操作成功',
                    });
                    dispatch.sceneManage.GET_CURRENT_PAGE();
                    dispatch.sceneManage.updateTable({});
                }
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign({}, initState));
        },
        // 待发拍场次删除
        sessionDelete(roundId) {
            Api.auction.deletePageAuctionRound({
                roundId,
            })
                .then((res) => {
                if (res) {
                    notification.success({
                        message: '删除成功',
                    });
                    dispatch.sceneManage.GET_CURRENT_PAGE();
                    dispatch.sceneManage.updateTable({});
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        GET_CURRENT_PAGE(state) {
            const page = state.tableData.length;
            const currentIndex = state.pageIndex;
            if (page === 1) { // 当前页只剩余1条数据
                const pageIndex = currentIndex > 1 ? currentIndex - 1 : 1;
                state.pageIndex = pageIndex;
            }
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
        SET_TABLELIST_NUM(state, payload) {
            const dealPayload = getDataType(payload) === 'Array' ? payload : [];
            state.tabList.forEach((item) => {
                const index = dealPayload.findIndex((v) => String(v.status) === item.key);
                item.num = index !== -1 ? dealPayload[index].number : 0;
            });
        },
    },
});
